import { Button as AntButton, ButtonProps as AntButtonProps } from 'antd';
import styles from './button.module.scss';
import { Size, Variant } from './button.types';

interface ButtonProps extends AntButtonProps {
  buttonVariant?: Variant;
  buttonSize?: Size;
  rightIcon?: boolean;
}

export function Button({
  buttonVariant = 'primary',
  buttonSize = 'small',
  rightIcon,
  ...props
}: ButtonProps) {
  const { className } = props;
  const buttonStatesClass = 'loading' in props ? styles.loadState : styles.pressState;
  const buttonIconClass =
    'icon' in props && rightIcon ? styles.rightIconButton : styles.leftIconButton;

  const classNames = [
    styles.button,
    styles[buttonVariant],
    styles[buttonSize],
    buttonStatesClass,
    buttonIconClass,
    className,
  ].join(' ');

  return <AntButton {...props} className={classNames} />;
}
